import { motion } from "framer-motion";
import { BRAND } from "@/lib/brand";
import { useMobilI18n } from "@/lib/mobilI18n";

export default function MobilIntro() {
  const { m } = useMobilI18n();
  return (
    <section id="que-es" data-testid="mobil-intro" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-[0_30px_60px_rgb(28,36,33,0.15)]">
            <img src={BRAND.mobilPhotos.intro} alt={m.name} loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#3e664c] text-[#fdfcf9] rounded-2xl px-6 py-5 shadow-[0_20px_40px_rgb(31,58,48,0.3)]">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#E2C9A0]">AURA</p>
            <p className="font-display text-2xl leading-none mt-1">{m.badge}</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{m.intro.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] leading-[1.05]">{m.intro.title}</h2>
          <p className="mt-6 text-[#5C544F] leading-relaxed max-w-2xl">{m.intro.p1}</p>
          <p className="mt-4 text-[#5C544F] leading-relaxed max-w-2xl">{m.intro.p2}</p>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-[#eae0df] pt-8">
            {m.intro.pillars.map((p, i) => (
              <div key={p.title} data-testid={`mobil-pillar-${i}`}>
                <span className="font-display text-[#C9A24B] text-2xl">0{i + 1}</span>
                <h3 className="mt-2 font-display text-xl text-[#1c2421]">{p.title}</h3>
                <p className="mt-1 text-sm text-[#5C544F] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
